import React from "react";
import image1 from "../../../images/blog/blog-01.jpg";
import image2 from "../../../images/blog/blog-02.jpg";

import BlogItem from "./BlogItem";

const blogData = [
  {
    id: 1,
    image: image1,
    title: "What is virtual DOM?",
    description:"Read My Blogs on Medium",
    Bloglink:"https://medium.com/@johnstarhafiz/react-concepts-4b37032ad3cf"
  },
  {
    id: 2,
    image: image2,
    title: "What is MySQL Database?",
    description:"Read My Blogs on Medium",
    Bloglink:"https://medium.com/@johnstarhafiz/react-concepts-4b37032ad3cf"
  }
];

const Blog = () => {
  return (
    <section className="pb-10">
    <h3 style={{textAlign:'center', marginTop:'60px', marginBottom:'40px', fontWeight:'bold', fontSize:'26px'}}>My Blogs On Medium</h3>
    <div style={{height:'5px', width:'50px', background:'#E54042', margin:'0 auto', marginTop:'-30px', marginBottom:'30px'}}></div>
      <div className="flex flex-wrap md:px-4">
        {blogData.map((blog, id) => (
          <BlogItem blog={blog} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Blog;
